module.exports = __webpack_public_path__ + "static/media/CH.a7a28cc0.wav";